import { User, Calendar, Award, Trophy, Thermometer, Flag } from 'lucide-react';
import { defineSchema, CANONICAL_CATEGORIES, CANONICAL_SESSION_TYPES } from '@shared/search';

export const trackLeaderboardSchema = defineSchema({
  id: 'track-leaderboard',
  title: 'filter.schema.trackLeaderboard.title',
  subtitle: 'filter.schema.trackLeaderboard.subtitle',
  defaultField: 'driver',
  fields: {
    driver: {
      key: 'driver',
      label: 'filter.field.driver',
      type: 'text',
      icon: User,
      placeholder: 'filter.placeholder.driver',
      description: 'filter.desc.driver',
      example: 'driver:Yanick',
    },
    season: {
      key: 'season',
      label: 'filter.field.season',
      type: 'number',
      icon: Calendar,
      description: 'filter.desc.season',
      example: 'season:2026',
      presets: [
        { label: '2026', value: '2026', operator: '=' },
        { label: '2025', value: '2025', operator: '=' },
        { label: '2024', value: '2024', operator: '=' },
      ],
    },
    category: {
      key: 'category',
      label: 'filter.field.category',
      type: 'enum',
      icon: Award,
      allowMultiple: true,
      description: 'filter.desc.category',
      options: CANONICAL_CATEGORIES,
      example: 'category:Max',
    },
    type: {
      key: 'type',
      label: 'filter.field.sessionType',
      type: 'enum',
      icon: Flag,
      allowMultiple: true,
      description: 'filter.desc.sessionType',
      options: CANONICAL_SESSION_TYPES,
      example: 'type:final',
    },
    pos: {
      key: 'pos',
      label: 'filter.field.position',
      type: 'range',
      icon: Trophy,
      min: 1,
      max: 50,
      description: 'filter.desc.position',
      example: 'pos:<=3',
      presets: [
        { label: 'filter.preset.posWinner', value: '1', operator: '=' },
        { label: 'filter.preset.posPodium', value: '3', operator: '<=' },
        { label: 'filter.preset.posTop5', value: '5', operator: '<=' },
        { label: 'filter.preset.posTop10', value: '10', operator: '<=' },
      ],
    },
    temp: {
      key: 'temp',
      label: 'filter.field.temp',
      type: 'range',
      icon: Thermometer,
      unit: '°C',
      min: -10,
      max: 50,
      description: 'filter.desc.temp',
      example: 'temp:15..25',
      presets: [
        { label: 'filter.preset.tempCool', value: '15', operator: '<' },
        { label: 'filter.preset.tempMild', value: '15', highValue: '25', operator: 'between' },
        { label: 'filter.preset.tempWarm', value: '25', operator: '>=' },
      ],
    },
    from: {
      key: 'from',
      label: 'filter.field.date',
      type: 'dateRange',
      icon: Calendar,
      description: 'filter.desc.date',
      example: 'from:-30d',
      datePresets: [
        { label: 'filter.preset.today', value: 'today' },
        { label: 'filter.preset.last7d', value: '-7d' },
        { label: 'filter.preset.last30d', value: '-30d' },
        { label: 'filter.preset.last90d', value: '-90d' },
        { label: 'filter.preset.last1y', value: '-1y' },
      ],
    },
  },
  examples: [
    { q: 'driver:Yanick season:2026', desc: 'filter.example.yanickFastest2026' },
    { q: 'pos:<=3 category:"Senior MAX"', desc: 'filter.example.podiumSeniorMax' },
    { q: 'temp:>=25 from:-90d', desc: 'filter.example.warm90d' },
  ],
});

